import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '@/store'
import { IClient } from '@/api/types-client'

export const defaultClient: IClient = {
  clientId: 0,
  name: '',
  company: '',
  address: '',
  city: '',
  state: '',
  postalCode: '',
  phone: '',
  email: '',
  imagePath: '',
  apiName: '',
  apiClientName: '',
  apiToken: '',
  apiWebHookUrl: '',
  notificationEmail: ''
  // reportOptions: null,
  // freddieMacOptions: null,
  // fannieMaeOptions: null
}

export interface IClientsState {
  ClientList: IClient[]
  ClientSelected: (IClient | null)
}

@Module({ dynamic: true, store, name: 'Client' })
class Clients extends VuexModule implements IClientsState {
  public ClientList: IClient[] = []
  public ClientSelected: IClient | null = null

  @Mutation
  private DEL_ALL_CLIENTS() {
    this.ClientList = []
  }

  @Mutation
  private LOAD_CLIENTS(Clients: IClient[]) {
    this.ClientList = Clients
  }

  @Mutation
  private SET_SELECTED(Client: IClient | null) {
    this.ClientSelected = Client
  }

  @Mutation
  private UPDATE_CLIENT(Client: IClient) {
    for (let v of this.ClientList) {
      if (v.clientId === Client.clientId) {
        v = Object.assign(v, Client)
        break
      }
    }
  }

  // GETTERS
  get cachedClients() {
    return this.ClientList
  }

  @Action
  public createNewClient(): IClient {
    return defaultClient
  }

  @Action
  public loadClients(Clients: IClient[]) {
    this.DEL_ALL_CLIENTS()
    this.LOAD_CLIENTS(Clients)
  }

  @Action
  public setSelectedClient(Client: IClient) {
    this.SET_SELECTED(Client)
  }

  @Action
  public updateClient(Client: IClient) {
    if (this.ClientSelected == null) return
    if (this.ClientSelected.clientId !== Client.clientId) return
    this.SET_SELECTED(Client)
    this.UPDATE_CLIENT(Client)
  }
}

export const ClientModule = getModule(Clients)
